import React, { useState } from 'react'
 
 
import ContainerLoadingList from './ContainerLoadingList';
import ContainerLoadingForm from './ContainerLoadingForm';

const ContainerLoading= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <ContainerLoadingForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <ContainerLoadingList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}  
    </>
  )
}

export default ContainerLoading